import React, { useEffect, useState } from 'react'
import { Text, Flex, Input, InputGroup, InputLeftAddon, Tooltip, Button } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { useOrcamentoPedido } from '../../../../../../../../contexts/OrcamentoPedidoProvider'
import { Select } from '../Select'
import { FiClipboard, FiMessageCircle } from 'react-icons/fi'
import { TextEditor } from '../../../../../../../../components/TextEditor'
import { useAgendamentoRetorno } from '../../../../Modais/AgendamentoRetornoCliente/hooks/useAgendamentoRetorno'

export const EmailOption = () => {
  const [isCustomEmail, setIsCustomEmail] = useState(false)
  const {
    register,
    formState: { errors },
    watch,
    control,
    setValue,
  } = useFormContext()
  const { infoProposta } = useOrcamentoPedido()

  const categorySelected = watch('categoria_email')
  const messageSelected = watch('mensagem_email')

  const {
    categoriesSistema: { data: categoriesData },
    mensagensEmail: { data: messagesData },
  } = useAgendamentoRetorno({
    id_categoria: categorySelected?.value,
    numeroPedido: infoProposta?.numero_pedido,
  })

  useEffect(() => {
    if (messageSelected?.conteudo_mensagem) {
      setValue('mensagem', messageSelected.conteudo_mensagem)
    }
  }, [messageSelected, setValue])

  const stripHtml = (html) => {
    const tmp = document.createElement('DIV')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
  }

  const formattedMessages =
    messagesData?.mensagens_padrao?.map((msg) => ({
      ...msg,
      value: msg.id_mensagem,
      label: stripHtml(msg.titulo_mensagem || msg.conteudo_mensagem).substring(0, 100) + '...',
      preview: msg.link_imagem || msg.conteudo_mensagem, // Adicionando suporte para preview de imagem
    })) || []

  const mensagemContent = watch('mensagem')
  useEffect(() => {
    if (isCustomEmail && mensagemContent) {
      setValue('mensagem_email', {
        value: 1,
        label: 'Email Personalizado',
        conteudo_mensagem: mensagemContent,
        preview: mensagemContent,
        id_mensagem: 0,
      })
    }
  }, [isCustomEmail, mensagemContent, setValue])

  const CustomEmailButton = () => (
    <Button
      w="100%"
      size="sm"
      colorScheme="blue"
      onClick={() => {
        setIsCustomEmail(true)
        setValue('categoria_email', {
          value: 1,
          label: 'Email Personalizado',
          id_categoria: 0,
        })
        setValue('mensagem_email', {
          value: 1,
          label: 'Email Personalizado',
          conteudo_mensagem: '',
          preview: '',
          id_mensagem: 0,
        })
        setValue('mensagem', '')
        setValue('assunto_email', '')
      }}
    >
      Escrever meu próprio email
    </Button>
  )

  if (isCustomEmail) {
    return (
      <Flex flexDir="column" gap={2} w="100%" justifyContent="flex-start" alignSelf="flex-start">
        <Button
          size="sm"
          variant="outline"
          colorScheme="blue"
          alignSelf="flex-start"
          onClick={() => {
            setIsCustomEmail(false)
            setValue('categoria_email', null)
            setValue('mensagem_email', null)
            setValue('mensagem', '')
            setValue('assunto_email', 'Assunto padrão')
          }}
        >
          Voltar para modelos
        </Button>

        <InputGroup size="sm">
          <Tooltip label="Essa parte do assunto do email é fixa e não pode ser alterada">
            <InputLeftAddon>Proposta de Fornecimento: {infoProposta?.numero_pedido} - Innovation Brindes</InputLeftAddon>
          </Tooltip>
          <Input
            placeholder="digite o restante do assunto"
            size="sm"
            borderColor={errors.assunto_email ? 'red.500' : '#3182ce'}
            borderRadius="md"
            borderLeftRadius={0}
            {...register('assunto_email')}
          />
        </InputGroup>
        {errors.assunto_email && (
          <Text color="red.500" fontSize="12px">
            {errors.assunto_email.message}
          </Text>
        )}

        <TextEditor control={control} name="mensagem" height="200px" noImage={true} />
      </Flex>
    )
  }

  return (
    <Flex flexDir="column" gap={2} w="100%" justifyContent="flex-start" alignSelf="flex-start">
      <Flex flexDir="column" alignItems="center" justifyContent="center" gap={4} py="16px" w="full" bg="#F5F5F5" rounded="md">
        <Button
          bg="white"
          borderColor="#378BBF"
          borderWidth="1px"
          borderRadius="6px"
          leftIcon={<FiMessageCircle size={25} color="#378BBF" />}
          color="black"
          maxW="337px"
          fontWeight="semibold"
          fontSize="15px"
          w="100%"
          size="sm"
          colorScheme="blue"
          onClick={() => {
            setIsCustomEmail(true)
            setValue('categoria_email', {
              value: 1,
              label: 'Email Personalizado',
              id_categoria: 0,
            })
            setValue('mensagem_email', {
              value: 1,
              label: 'Email Personalizado',
              conteudo_mensagem: '',
              preview: '',
              id_mensagem: 0,
            })
            setValue('mensagem', '')
            setValue('assunto_email', '')
          }}
        >
          Escrever meu próprio email
        </Button>
        <Text>
          Ou selecione <strong>uma das mensagens prontas abaixo </strong>
          para agilizar seu agendamento
        </Text>
      </Flex>

      <Select
        name="categoria_email"
        icon={FiClipboard}
        label={categorySelected ? categorySelected.label : 'Selecione uma categoria'}
        options={categoriesData?.categorias_mensagem?.map((cat) => ({
          value: cat.id_categoria,
          label: cat.descricao_categoria,
        }))}
      />

      {categorySelected && (
        <Select
          name="mensagem_email"
          icon={FiMessageCircle}
          label={messageSelected ? messageSelected.label : 'Selecione uma mensagem'}
          options={formattedMessages}
          hasToolTip
        />
      )}

      {categorySelected && (
        <>
          <InputGroup size="sm">
            <Tooltip label="Essa parte do assunto do email é fixa e não pode ser alterada">
              <InputLeftAddon>Proposta de Fornecimento: {infoProposta?.numero_pedido} - Innovation Brindes</InputLeftAddon>
            </Tooltip>
            <Input
              placeholder="digite o restante do assunto"
              size="sm"
              borderColor={errors.assunto_email ? 'red.500' : '#3182ce'}
              borderRadius="md"
              borderLeftRadius={0}
              {...register('assunto_email')}
            />
          </InputGroup>
          {errors.assunto_email && (
            <Text color="red.500" fontSize="12px">
              {errors.assunto_email.message}
            </Text>
          )}

          <TextEditor readOnly={!isCustomEmail} control={control} name="mensagem" height="200px" noImage={true} />
        </>
      )}
    </Flex>
  )
}
